<template>
  <div>

    <div class="table-reponsive text-nowrap" style="overflow: auto">
      <table class="table table-striped table-hover table-bordered table-sm">
        <thead>
          <th v-for="(field, index) of fields" :key="index" :style="{width: field.width}">{{ field.label }}</th>
        </thead>
        <tbody>
          <tr v-if="loading">
            <td :colspan="fields.length" class="text-center">
              <div class="text-center text-primary my-2">
                <b-spinner class="align-middle mr-2"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </td>
          </tr>
          <tr v-for="(item, itemIndex) of items" :key="itemIndex" v-else>
            <td>{{ (currentPage * perPage)-perPage + itemIndex + 1 }}</td>
            <td v-for="(field, fieldIndex) of fields.filter(element => element.key != 'actions' && element.key != 'no')" :key="fieldIndex">
              <div v-if="field['key'] == 'employee'">{{ items[itemIndex][field['key']]['fullName'] }}</div>
              <div v-else-if="field['key'] == 'leaveType'">{{ items[itemIndex][field['key']]['paramListDesc'] }}</div>
              <div v-else-if="field['key'] == 'reimburseCategory'">{{ items[itemIndex][field['key']]['paramListDesc'] }}</div>
              <div v-else-if="field['key'] == 'stay'"><span class="badge text-capitalize badge-pill" :class="items[itemIndex][field['key']]['stay'] ? 'badge-light-success' : 'badge-light-danger'">{{ items[itemIndex][field['key']]['stay'] ? 'Ya' : 'Tidak' }}</span></div>
              <div v-else-if="field['key'] == 'transportType'">{{ items[itemIndex][field['key']]['paramListDesc'] }}</div>
              <div v-else-if="field['key'] == 'wfh'"><span class="badge text-capitalize badge-pill" :class="items[itemIndex][field['key']]['wfh'] ? 'badge-light-success' : 'badge-light-danger'">{{ items[itemIndex][field['key']]['wfh'] ? 'Ya' : 'Tidak' }}</span></div>
              <div v-else-if="field['key'] == 'attendanceType'">{{ attendanceType(items[itemIndex][field['key']]) }}</div>
              <div v-else-if="field['key'] == 'countTime'">{{ timeConvert(items[itemIndex][field['key']]) }}</div>
              <div v-else-if="field['key'] == 'amount'">{{ rupiah(items[itemIndex][field['key']]) }}</div>
              <div v-else-if="field['key'] == 'totalDiscovery'">{{ rupiah(items[itemIndex][field['key']]) }}</div>
              <div v-else-if="field['key'] == 'city'">{{ items[itemIndex][field['key']] ? items[itemIndex][field['key']]['cityName'] : '-' }}</div>
              <div v-else-if="field['key'] == 'systemParameter'">{{ items[itemIndex][field['key']]['paramName'] }}</div>
              <div v-else-if="field['key'] == 'roleImplement'">{{ items[itemIndex][field['key']]['roleName'] }}</div>
              <div v-else-if="field['key'] == 'product'">{{ items[itemIndex][field['key']]['paramListDesc'] }}</div>
              <div v-else-if="field['key'] == 'loanAmount'">{{ rupiah(items[itemIndex][field['key']]) }}</div>
              <div v-else-if="field['key'] == 'band'">{{ items[itemIndex][field['key']]['bandName'] }}</div>

              <div v-else>{{ items[itemIndex][field['key']] }}</div>
            </td>
            <td v-if="!HideOptions">
              <span><b-button variant="outline-primary" size="sm" class="mr-1" @click="detailItem(item)" v-if="!hideView" >View</b-button></span>
              <span><b-button variant="outline-primary" size="sm" class="mr-1" @click="editItem(item)" v-if="!hideUpdate">Update</b-button></span>
              <span><b-button variant="outline-danger" size="sm" class="mr-1" @click="deleteItem(item)" v-if="!hideDelete">Delete</b-button></span>
            </td>
          </tr>
          <tr v-if="items.length == 0 && !loading">
              <td :colspan="fields.length" class="text-center">
                Data tidak tersedia
              </td>
            </tr>
        </tbody>
      </table>
    </div>

     <div class="mt-2">
      <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          @change="handlePageChange">
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>
          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
      </b-pagination>
     </div>

  </div>
</template>

<script>
import {
  BSpinner,
  BTable,
  BButton,
  BPagination,
} from "bootstrap-vue";

export default {

  components: {
    BTable,
    BButton,
    BSpinner,
    BPagination,
  },

  props: {
    hideView: [Boolean],
    hideUpdate: [Boolean],
    hideDelete: [Boolean],
    fields: {
      type: Array,
    },
    items: {
      type: Array,
    },
    loading: {
      type: Boolean,
    },
    HideOptions: [Boolean],
    rows: {
      type: Number,
    },
    perPage: {
      type: Number,
    },
    currentPage: {
      type: Number,
    },
    handlePageChange: {
      type: Function
    },
    detailItem: {
      type: Function
    },
    editItem: {
      type: Function
    },
    deleteItem: {
      type: Function
    },
  },

  methods: {
    onFiltered(filteredItems) {
        // To Do
    },
    attendanceType(data) {
      let text = '-';
      switch (data) {
        case 'H':
          text = "Hadir";
          break;
        case 'I':
          text = "Izin";
          break;
        case 'C':
          text = "Cuti";
          break;
        case 'A':
          text = "Alpha";
          break;
      }

      return text
    },
    timeConvert(n) {
      var num = n;
      var hours = (num / 60);
      var rhours = Math.floor(hours);
      rhours = ("0" + rhours).slice(-2);
      var minutes = (hours - rhours) * 60;
      var rminutes = Math.round(minutes);
      rminutes = ("0" + rminutes).slice(-2);
      return rhours + ":" + rminutes;
    },
    rupiah(angka, prefix){

      if (angka == null) {
        return '-'
      }

      const format = angka.toString().split('').reverse().join('');
      const convert = format.match(/\d{1,3}/g);
      const rupiah = 'Rp ' + convert.join('.').split('').reverse().join('')

      return rupiah
		}
  },

};
</script>

<style scoped>

.table th {
  padding: 8px !important;
}

</style>
